import React from 'react'

import Hero from './Hero';
import CreateTicket from './CreateTicket';
function SupportPage() {
    return (
        // <h1>Support Page</h1>
        <>
            <Hero />
            <CreateTicket />
        </>
    );
}

export default SupportPage;